<script>
import TwButton from '@/components/generic/tw-button.vue'
import { useFundraiserStore } from '@/stores/fundraiser.js'
import TwPaginator from '@/components/generic/tw-paginator.vue'
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'
import FundraiserCreateModal from '@/components/fundraisers/fundraiser-create-modal.vue'
import TwCard from '@/components/generic/tw-card.vue'
import fetchItemsMixinWithWatcher from '@/mixins/fetchItemsMixinWithWatcher.js'
import TwContainer from '@/components/generic/tw-container.vue'
import TwTable from '@/components/generic/table/tw-table.vue'
import FundraiserManageDropdown from '@/components/fundraisers/fundraiser-manage-dropdown.vue'
import TwBadge from '@/components/generic/tw-badge.vue'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'
export default {
  name: 'FundraisersIndexPage',
  components: { TwLoadingSpinner, TwBadge, FundraiserManageDropdown, TwTable, TwContainer, TwCard, FundraiserCreateModal, TwTransitionContainer, TwPaginator, TwButton },
  mixins:[fetchItemsMixinWithWatcher],
  props: {
    selectorMode: {
      type: Boolean,
      default: false
    },
    modelValue:{
      type: [Object],
      default: null
    },
    selectDisabledHandler: {
      type: Function,
      default: () => false
    },
    selectorLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      SelectedRowsIdsLocal: null
    }
  },
  computed: {
    itemsStoreModule() {
      return useFundraiserStore(this.selectorMode? 'fundraiserSelectorMode' : null)
    },
    fields() {
      return [
        { name: 'title', label: 'Title', sortable: true, searchable: true },
        { name: 'created_at', label: 'Created', sortable: true, formatter: (item) => this.$filters.formatDate(item) },
        { name: 'cached.raised', label: '$ Raised', sortable: false,formatter: (item) => this.$filters.formatCurrency(item) },
        { name: 'goal', label: 'Goal', sortable: true, formatter: (item) => this.$filters.formatCurrency(item) },
        { name: 'cached.percentage_raised', label: '% Raised', sortable: false, formatter: (item) => item + '%' },
        { name: 'cached.remaining', label: 'Remaining', sortable: false, formatter: (item) => this.$filters.formatCurrency(item) },
        { name: 'deadline', label: 'Deadline', sortable: true, formatter: (item) => this.$filters.formatDate(item)  },
        { name: 'published', label: 'Published', sortable: true, formatter: (item) => item? 'Published':'Not Published'  },
        { name: 'actions', label: ' ', sortable: false },
      ]
    }
  },
  mounted() {
    this.fetchItems({ clear: true })
  },
  beforeUnmount () {
    this.itemsStoreModule.clearItems()
  },
  methods: {
    async fundraiserCreated(fundraiser) {
      await this.$router.push({ name: 'FundraiserDetailsPage', params: { fundraiserId: fundraiser.id } })
    },
    selectedRows(selectedRowsIds) {
      this.SelectedRowsIdsLocal = selectedRowsIds
    },
    rowClassParser(row) {
      return row.published? 'bg-amber-100' : ''
    }
  }
}
</script>

<template>
  <div>
    <div v-if="!selectorMode">
      <tw-button class="float-right" @click="$refs.fundraiserCreateModal.open()">
        Create {{ $t('Fundraiser') }}
      </tw-button>
      <h2>My {{ $t('Fundraiser',2) }}</h2>
    </div>
    <tw-loading-spinner v-if="selectorLoading">
      Processing selected {{ $t('fundraiser') }}...
    </tw-loading-spinner>
    <tw-card class="bg-white p-4 rounded-2xl min-h-screen mt-6">
      <!-- <tw-paginator v-if="showPaginator" v-model="page" class="justify-self-end mb-6" :per-page="perPage" :total="total" /> -->
      <div class="clear-both" />
      <tw-transition-container>
        <tw-table class="mt-4" :loading="LoadingFetchingItems" :rows="items" :fields="fields" :filters="filters" :order-by="orderBy" :order-direction="orderDirection" @update:selected-rows="selectedRows" @sort-changed="sortChanged" @filters-changed="filtersChanged" @fetch-items="fetchItems">
          <template #cell(title)="data">
            <router-link :to="{ name: 'FundraiserDashboardPage', params: { fundraiserId: data.row.id } }" class="underline">
              {{ data.value }}
            </router-link>
          </template>

          <template #cell(published)="data">
            <tw-badge :variant="data.row.published? 'green':'amber'">
              {{ data.row.published? 'Published': 'Not Published' }}
            </tw-badge>
          </template>
          <template #cell(actions)="data">
            <fundraiser-manage-dropdown v-if="!selectorMode" :key="'fundraiser-manage-dropdown-' + data.row.id" :fundraiser="data.row" />
            <tw-button v-else variant="primary" :disabled="selectDisabledHandler(data.row) || selectorLoading" @click="$emit('update:modelValue', data.row)">
              Select
            </tw-button>
          </template>
        </tw-table>
      </tw-transition-container>
      <div v-if="showPaginator" class="border-t">
        <tw-paginator v-model="page" class="justify-self-end mt-6" :per-page="perPage" :total="total" />
      </div>
    </tw-card>
    <fundraiser-create-modal ref="fundraiserCreateModal" @created="fundraiserCreated" />
  </div>
</template>

<style scoped>

</style>
